import { React, useState } from 'react'
import styles from './SyncChart.module.scss'
import { useGeoState } from '../../../components/GeoProvider'
import ErrorMessage from '../../../components/Layout/ErrorMessage'
import { useAuthState } from '../../../components/AuthProvider'
import IDPChart from '../../../components/IDPCharts/IDPChart'
import lineAreaChartOptions from '../../../components/LineAreaChart/lineAreaChartOptions'
const AreaChart = ({ data,geo_id}) => {
  const {locationName,displayDate} =useGeoState()

    let chartData=[]
  if(data===null)
    {return (<div className={styles.base}>Data Not Available</div>)}
  else{
    
    data.map((data_val) => {
      let json=JSON.parse(data_val.json_value)
      let data_array=[]
      json.map((data_v)=>{
        data_v.total_counts<=-1?data_array.push([Date.parse(data_v.week_ending),null]):data_array.push([Date.parse(data_v.week_ending),data_v.total_counts])
      })
      let obj={
              "disease_id": 1,
              "name": data_val.category_name,
              "geo_type": "nat",
              "json_value": data_array
              }
      chartData.push(obj)
    })
  
    let chartColors=['#15A796','#C72887','#8061BC','#E4780C','#1E82CB']
    let lineChartData=[]
    for(let i=0;i<chartData.length;i++)
      {
          var obj={
              name: chartData[i].name,
              data:  chartData[i].json_value,
              color: chartColors[i],
              visible: true,
              showInLegend: true,
              fillOpacity:.2
            }
            lineChartData.push(obj)
      }
  
    const lineOptions = lineAreaChartOptions(
      lineChartData,
      geo_id,locationName
    )
     
    
      
      return  (
      <div className={styles.base}>
          <IDPChart
                chartOptions={lineOptions}
                height={'350px'}
              />
        </div>
    ) 
    
  }
 
}

export default AreaChart
